import { render, staticRenderFns } from "./BillingClientSpace.vue?vue&type=template&id=2be7b125&scoped=true"
import script from "./BillingClientSpace.vue?vue&type=script&lang=js"
export * from "./BillingClientSpace.vue?vue&type=script&lang=js"
import style0 from "./BillingClientSpace.vue?vue&type=style&index=0&id=2be7b125&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be7b125",
  null
  
)

export default component.exports